import React, { useEffect, useRef, useState } from "react";
import Header from "../../../components/global/Header";
import LeftNavbar from "../../../components/global/LeftNavbar";
import { useTranslation } from "react-i18next";
import { dateFormatAndStatus, transformBlankToNull } from "../../../services/Util";
import { Link } from "react-router-dom";
import { getAxiosResponse,postAxiosResponse,putAxiosResponse } from "../../../services/authApiRoutes/APImethods";
import APIUrls from "../../../services/APIUrls";
import { useNavigate } from "react-router-dom";
import Constants from "../../../Constants";
import $ from "jquery";
import SuccessMessage from "../../../components/SuccessMessage";
import { RotatingLines } from "react-loader-spinner";
import { Breadcrumb } from "../../../components/dashboard/Breadcrumb";
import { useSelector } from 'react-redux';

export default function SystemSettingNDA() {
  const scrollRef = useRef(null);
  const backRef = useRef();
  const { t } = useTranslation();
  const translate = t;
  const navigate = useNavigate();
  const [newNda, setNewNda] = useState("");
  const [ndaDetail,setNdaDetail] = useState('')
  const [ndaInfo, setndaInfo] = useState("");
  const [allNdaVersions, setNdaVersions] = useState({});
  const [allAcceptedNDA, setAllAcceptedNDA] = useState([]);
  const [customerWideNDAInUse,setCustomerWideNDAInUse] = useState(null);
  const [successMessage, setSuccessMessage] = useState("");
  const [charsLeft, setCharsLeft] = useState(20000);
  const [showLoader,setShowLoader] = useState(false);
  const [showAcceptedLoader,setShowAcceptedLoader] = useState(false);
  const custBootstrapDataRedux = useSelector(
    (store) => store.customer_bootstrap_data
  ).value;

  const ndaInfoEdit = (type) => {
    if(type === 'add'){
      setNdaDetail('');
    }
    if(type === 'clear'){
      setNewNda('');
      setNdaDetail('');
      setCharsLeft(20000);
    }
    setndaInfo(!ndaInfo);
    $(".lastdisable").trigger("focus");
  };

  useEffect(() => {
    if (successMessage !== Constants.BLANK) {
      setTimeout(function () {
        setSuccessMessage(Constants.BLANK);
      }, 5000);
    }
  }, [successMessage]);

  const handleAreaChange = (value)=>{
    setNewNda(value);
    setCharsLeft(20000-value.trim().length);
  };

  const getNdaDetail = (id) =>{
    getAxiosResponse(APIUrls.GET_NDA_DETAIL(id))
    .then((res) => {
      setNdaDetail(res.data.data);
      ndaInfoEdit('view');
    }).catch((err) => {
      console.error(err);
    });
    $(".lastdisable").trigger("focus");
  }

  const handleChangeCustomerWideNDAInUse = (e) =>{
    let flag = e.target.id === 'yes';
    setCustomerWideNDAInUse(flag);
    if (flag !== allNdaVersions.customerWideNDAInUse) {
      $("#change-data").removeClass("disabled-data");
    } else {
      $("#change-data").addClass("disabled-data");
    }
  };

  const createNewNda = () => {
    var payload = {text : newNda.trim()}
    postAxiosResponse(APIUrls.GET_NDA_LIST,payload)
    .then((res) => {
      getData();
      setNewNda("");
      ndaInfoEdit('add');
    }).catch((err) => {
      console.error(err);
    });
  };

  const getData = () =>{
    setShowLoader(true);
    setShowAcceptedLoader(true);
    getAxiosResponse(APIUrls.GET_NDA_LIST)
    .then((res) => {
      const data = res.data.data;
      if(data){
        setNdaVersions(data);
        setCustomerWideNDAInUse(data.customerWideNDAInUse);
      }
      setShowLoader(false);
    }).catch((err) => {
      console.error(err);
    });

    getAxiosResponse(APIUrls.GET_NDA_ACCEPTED_LIST)
    .then((res) => {
        setAllAcceptedNDA(res.data.data);
        setShowAcceptedLoader(false);
    })
    .catch((err) => {
        console.error(err);
    });
  }

  useEffect(() => {
    getData()
      
  }, []);

 const updateCustomerWideNDAInUse = ()=>{
  allNdaVersions.customerWideNDAInUse = customerWideNDAInUse
  var payload = transformBlankToNull(allNdaVersions)
  putAxiosResponse(APIUrls.GET_NDA_LIST,payload)
  .then((res) => {
    const data = res.data.data;
    setNdaVersions(data);
    setCustomerWideNDAInUse(data.customerWideNDAInUse);
    $("#change-data").addClass("disabled-data");
    setSuccessMessage("NDA settings updated");

    setTimeout(() => {
      $(".lastdisable").trigger("focus");
    }, 5000);

  }).catch((err) => {
      console.error(err);
  });
 }


 
 const crumbs = [
  {label:'Settings', url:'settings'},
  {label:'Non-Disclosure Agreement', url:''},
 ];
  return (
    <>
      <div className="body bg-color">
        <div id="container" className="dashboard-wrapper">
          <Header ref={scrollRef} />
          <LeftNavbar />
          <section className="dashboard-content" ref={scrollRef}>
            <div id="content" className="dashboard-wrap">
              <Breadcrumb crumbs={ crumbs } />
              <div className="system-setting-page">
                <div className="project-heading userprofile-heading">
                  <div className="back-arrow flex-center" onClick={ ndaInfo ?  () => setndaInfo('') : () =>navigate("/settings")}>
                    <button ref={backRef} aria-label="Back to Non-Disclosure Agreement list">
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="13" viewBox="0 0 14 13" fill="none">
                        <path d="M0.46967 5.96967C0.176777 6.26256 0.176777 6.73744 0.46967 7.03033L5.24264 11.8033C5.53553 12.0962 6.01041 12.0962 6.3033 11.8033C6.59619 11.5104 6.59619 11.0355 6.3033 10.7426L2.06066 6.5L6.3033 2.25736C6.59619 1.96447 6.59619 1.48959 6.3033 1.1967C6.01041 0.903806 5.53553 0.903806 5.24264 1.1967L0.46967 5.96967ZM1 7.25H14V5.75H1V7.25Z"
                          fill="#1D4ED8"/>
                      </svg>
                    </button>
                    <span>{ndaInfo ? "Back to Non-Disclosure Agreement list" :"Back to Settings"}</span>
                  </div>
                  <h3>Non-Disclosure Agreement (NDA)</h3>
                  <span>
                    Add your Company Non-Disclosure Agreement. Vendors will be
                    required to accept it before having access to your future
                    projects.
                  </span>
                </div>
                <div className="white-bg">
                  <div className={!ndaInfo ? "NDA-page show" : "NDA-page hide"}>
                  {customerWideNDAInUse !==null?
                    <div className="purchase-yesno-list mar-bot40">
                      <fieldset className="radio-fieldset">
                        <legend className="heading-width-border">
                          Choose if your Non-Disclosure Agreement will be applied to
                          your future projects
                        </legend>
                        <div className="radio-form-check">
                          <input type="radio" className="form-check-input" name="radio" id="no"
                            checked={!customerWideNDAInUse}
                            onChange={handleChangeCustomerWideNDAInUse} />
                          <label className="form-check-label" htmlFor="no">
                            No, do not apply the Company NDA to future projects.
                          </label>
                        </div>
                        <div className="radio-form-check">
                          <input type="radio" className="form-check-input" name="radio"
                            id="yes" checked={customerWideNDAInUse} 
                            onChange={handleChangeCustomerWideNDAInUse}/>
                          <label className="form-check-label" htmlFor="yes">
                            Yes, apply the most recent version of the Company NDA.
                            Vendors will only have access to future projects after
                            they read and accept it.
                          </label>
                        </div>
                      </fieldset>
                      <button id="change-data" className="blue-btn active mar-top30 disabled-data" 
                      onClick={()=>updateCustomerWideNDAInUse()}>Save</button>
                    </div>
                  :Constants.BLANK}  

                    <div className="non-disclosure-table mar-bot40">
                      <div className="flex heading-with-rightbtn">
                        <h6>Company Non-Disclosure Agreement</h6>
                        <div className="flex two-col flex-center">
                          <button className="dashboard-btn" onClick={()=>ndaInfoEdit('add')}>
                            <svg className="plus-icon" xmlns="http://www.w3.org/2000/svg"
                              width="12" height="12" viewBox="0 0 12 12" fill="none" >
                              <path d="M6 1V11" stroke="#1D4ED8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                              <path d="M1 6H11" stroke="#1D4ED8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"  />
                            </svg>
                           New version
                          </button>
                        </div>
                      </div>
                      <div className="table-responsive global-table auto-width-table">
                        <table className="sortable" aria-label="Company Non Disclosure Agreement">
                          <thead>
                            <tr>
                              <th>Version</th>
                              <th>Created On</th>
                            </tr>
                          </thead>
                          {showLoader ? 
                          (<tbody>
                            <tr>
                            <td id="loader-center" colSpan="2">
                            <RotatingLines strokeColor="#0096FF" strokeWidth="5" animationDuration="0.75" width="196" visible={true} />
                            </td>
                            </tr>
                            </tbody>):
                          (
                            <tbody>
                              {allNdaVersions !== undefined ? allNdaVersions.customerNDAs?.map((nda, index) => {
                                return (
                                  <tr key={index}>
                                    <td>
                                      <Link to="#" onClick={()=>getNdaDetail(nda.id)}>
                                        Version{" "}
                                        {allNdaVersions?.customerNDAs.length - index}{" "}
                                      </Link>{" "}
                                      {index === 0 ? "(this version will be used for the next project)" : Constants.BLANK}
                                    </td>
                                    <td>
                                    <div className="relative text">
                                  <span className="font-zero setFastpass">
                                  {dateFormatAndStatus(nda.createdDateWithTime, Constants.DATE_FORMAT_LL_HH_MM_SS_A,custBootstrapDataRedux.user?.timeZone)[0]}
                                  </span>
                                  <span aria-hidden="true">{nda.createdDateWithTime}
                                  </span>
                                </div>
                                      {/* {nda.createdDateWithTime} */}
                                    </td>
                                  </tr>
                                );
                              }):<tr></tr>}
                            </tbody>
                          )
                        }
                        </table>
                      </div>
                    </div>

                    <div className="non-disclosure-table mar-bot40">
                      <h5 className="heading-width-border mar-bot20">
                        Vendors Who Accepted Non-Disclosure Agreement
                      </h5>
                      <div className="table-responsive global-table auto-width-table">
                        <table className="sortable" aria-label="Vendors Who Accepted Non Disclosure Agreement">
                          <thead>
                              <tr>
                                <th>Vendor Name</th>
                                <th>User</th>
                                <th>NDA Version</th>
                                <th>Accepted On</th>
                              </tr>
                          </thead> 
                          {showAcceptedLoader ?
                          (<tbody>
                          <tr>
                            <td id="loader-center-accepted" colSpan="4">
                            <RotatingLines strokeColor="#0096FF" strokeWidth="5" animationDuration="0.75" width="196" visible={true} />
                            </td>
                            </tr>
                            </tbody>
                            ):
                          (
                            <tbody>
                              {allAcceptedNDA?.map((vendor,index)=>{
                                  return(
                                    <tr key={index}>
                                      <td>{vendor.vendor.name}</td>
                                      <td>{vendor.vendorUser.firstName +' '+ vendor.vendorUser.lastName}</td>
                                      <td>V {vendor.versionNumber}</td>
                                      <td>{vendor.lastModifiedDateWithTime}</td>
                                    </tr>
                                  )
                              })
                              }
                            </tbody>)}   
                        </table>
                      </div>
                    </div>
                  </div>

                  <div
                    className={!ndaInfo? "add-new-version-block hide": "add-new-version-block show"}>
                    {ndaDetail === '' ?<p>
                      Add the text of your Non-Disclosure Agreement in the box
                      below and click Save. Please make sure that you separate
                      your text into sections and paragraphs to make it easily
                      readable.
                    </p>: <strong>Saved on {ndaDetail.createdDateWithTime}</strong>}
                    <div className="flex wrap-dropdown">
                      <div className="global-dropdown-block w-d100 mb-0">
                        <textarea className="textarea" placeholder="Please enter description"
                            maxLength={20000}
                            disabled={ndaDetail === ''?false:true}
                          spellCheck="false" aria-label="Add the text of your Non-Disclosure Agreement" onChange={(e) => handleAreaChange(e.target.value)}
                          value={ndaDetail !== '' ? ndaDetail.text : newNda}
                        ></textarea>
                      </div>
                      {ndaDetail === ''?
                      <div>{charsLeft.toLocaleString()} characters left</div>:Constants.BLANK}
                    </div>
                    
                    <div className="flex two-col justify-end">
                      <button className="blue-btn" onClick={()=>ndaInfoEdit('clear')}>
                        Cancel
                      </button>
                      {ndaDetail === '' ? 
                      <button className={newNda?.trim() === "" ? "blue-btn active disabled":"blue-btn active"}
                        disabled={newNda?.trim() === ""} onClick={createNewNda}>
                        Save
                      </button>
                      : Constants.BLANK}
                    </div>
                    
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      {(successMessage !== undefined && successMessage !== Constants.BLANK) ? <SuccessMessage message={successMessage} /> : Constants.BLANK}
    </>
  );
}
